export default "__VITE_ASSET__sDjHHDO6__"